import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

const highlightOrderService = {
  // GET: Fetch Highlights
  async getHighlights(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v1/highlights`, {
        params,
      });
      return response.data;
    } catch (error) {
     
      throw error;
    }
  },

  async addToHighLight(highLightData) {
    try {
      const formData = highLightData;
      const response = await requestInstance.post(`${BASE_URL}/admin-api/v1/highlights`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  async updateHighLight(highLightData, id) {
    try {
      const formData = highLightData;
      const response = await requestInstance.put(`${BASE_URL}/admin-api/v1/highlights/${id}`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  async saveHighLightOrder(highLightData) {
    try {
      const formData = highLightData;
      const response = await requestInstance.post(`${BASE_URL}/admin-api/v1/highlights/reorder`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  async deleteHighLight(id) {
    try {
      
      const response = await requestInstance.delete(`${BASE_URL}/admin-api/v1/highlights/${id}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },
};

export default highlightOrderService;